import { GetStaticProps } from 'next';
import { getDestinationList } from '@/common/service/api/Destination/Destination';
import {
    fetchItinerary,
    fetchByItinerary,
    fetchUserImagesByActivityIds,
} from '@/entities/Itinerary/service/fetchItinerary';
import { ItineraryPage } from '@/screens/ItineraryPage/ui/Itinerary';
import { ActivitiesItineraryProps } from '@/screens/ItineraryPage/domain/ItineraryPage.domain';
import { getRedirectsPath } from '@/common/service/api/Redirects/getRedirectsPath';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

type PageStaticProps = {
    slug: string;
};

export const getStaticProps: GetStaticProps<ActivitiesItineraryProps, PageStaticProps> = async ({
    params,
}) => {
    if (!params) {
        throw new Error(`PAGE ITINERARY: BAD PARAMS: ${params}`);
    }

    try {
        const destinations = await getDestinationList();
        const itinerary = await fetchItinerary(params);
        const currentPath = `/itinerary/${params.slug}/`;

        if (!itinerary.length) {
            const redirectPath = await getRedirectsPath(currentPath);

            if(redirectPath === '/404/'){
                return {
                    notFound: true,
                };
            }
            
            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect:{
                    destination: redirectPath.toLowerCase(),
                    statusCode: 301,
                },
            };
        }

        const rightPath = `/itinerary/${itinerary[0].slug}/`.toLowerCase();

        if(currentPath !== rightPath){
            return {
                revalidate: Number(process.env.CACHE_ENV),
                redirect:{
                    destination: rightPath,
                    statusCode: 301,
                },
            };
        };

        const destinationId = Number(itinerary[0].destination_id);

        const pageDestination =
            destinations.items.find((destination) => parseInt(destination?.id) == destinationId) ||
            destinations.items[0];

        const data = await fetchByItinerary({
            itinerary_id: itinerary[0].id,
            limit: 10,
            offset: 0,
        });

        let activity_ids = data.activity_ids,
            items = data.items,
            offset = data.items.length,
            count = 0;
        const total = data.total;

        while (total > items.length && count < 10) {
            const more = await fetchByItinerary({
                itinerary_id: itinerary[0].id,
                offset,
                limit: 10,
            });
            activity_ids += more.activity_ids ? `,${more.activity_ids}` : '';
            items = [...items, ...more.items];
            offset += more.items.length;
            count += 1;
        }
        /* TODO remove if we will not use additional images */
        const userImages = activity_ids ? await fetchUserImagesByActivityIds(activity_ids) : {};

        return {
            props: {
                pageDestination,
                itinerary: itinerary[0],
                items,
                userImages,
            },
        };
    } catch (e) {
        throw new Error((e as Error).message);
    }
};

export default ItineraryPage;
